import React from 'react';
import Icon from 'components/icon';
import { func, bool, string } from 'prop-types';

export default class DocketCostCode extends React.Component {
    constructor(props) {
        super(props);

        this.inputChanged = this.inputChanged.bind(this);
    }

    inputChanged(event) {
        const { primaryCostCodeChangeHandler } = this.props;
        primaryCostCodeChangeHandler(event.target.value);
    }

    render() {
        const {
            title, desc, buttonTitle, editing,
            primaryCostCode, actionButtonHandler, cancelButtonHandler
        } = this.props;

        return (
            <div className="cost-code-top-container">
                <h2 className="cost-code-top-title">{title}</h2>
                <p className="cost-code-top-desc">
                    {desc}
                </p>
                <div className="cost-code-top-input-row">
                    {!editing &&
                        <button className="btn-costcode" onClick={actionButtonHandler}>{buttonTitle}</button>
                    }
                    {editing &&
                        <React.Fragment>
                            <div className="cost-code-top-input-wrapper">
                                <input
                                    id="primary-cost-code-input"
                                    type="text"
                                    maxLength="20"
                                    placeholder="Enter Cost Code"
                                    onChange={this.inputChanged}
                                    value={primaryCostCode}
                                />
                            </div>
                            <button
                                className="btn-costcode"
                                onClick={() => actionButtonHandler(primaryCostCode)}
                            >
                                {buttonTitle}
                            </button>
                            <button className="btn-costcode-plain" onClick={cancelButtonHandler}>Cancel</button>
                        </React.Fragment>
                    }
                </div>
                {editing &&
                    <div className="cost-code-top-edit-notification">
                        You can also add a cost code for items below by clicking &nbsp;
                        <Icon glyph="pencil" />.
                    </div>
                }
            </div>
        );
    }
}

DocketCostCode.propTypes = {
    title: string.isRequired,
    desc: string.isRequired,
    buttonTitle: string.isRequired,
    editing: bool.isRequired,
    primaryCostCode: string,
    actionButtonHandler: func.isRequired,
    cancelButtonHandler: func.isRequired,
    primaryCostCodeChangeHandler: func.isRequired
};

DocketCostCode.defaultProps = { primaryCostCode: '' };
